import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import vanBanModule from "./modules/van-ban";
import nhomChucVuModule from "./modules/quan-ly-nhom-chuc-vu";
import donViModule from "./modules/quan-ly-don-vi";
import nhiemVuModule from "./modules/nhiem-vu";
import permissionModule from "./modules/permission";
import congViecModule from "./modules/cong-viec";
import commonModule from "./modules/common";
import thongBaoModule from "./modules/thong-bao";
import quanLyTemplateModule from "./modules/quan-ly-template";
import vanBanDenModule from "./modules/van-ban-den";
import vanBanDi from "./modules/van-ban-di";
import BaoCaoModule from "./modules/bao-cao";
import wordOnline from "./modules/word-online";
import quanTriHeThongModule from "./modules/quan-tri-he-thong";
import hoSoCongViec from "./modules/ho-so-cong-viec";
import pakn from "./modules/pakn";
import hoSoLuuTru from "./modules/ho-so-luu-tru";
import stepUp from "./modules/step-up";

export default new Vuex.Store({
  modules: {
    vanBan: vanBanModule,
    nhomChucVu: nhomChucVuModule,
    donVi: donViModule,
    nhiemVu: nhiemVuModule,
    permission: permissionModule,
    congViec: congViecModule,
    thongBao: thongBaoModule,
    common: commonModule,
    quanLyTemplate: quanLyTemplateModule,
    vanBanDen: vanBanDenModule,
    vanBanDi,
    BaoCao: BaoCaoModule,
    quanTriHeThong: quanTriHeThongModule,
    wordOnline,
    hoSoCongViec,
    pakn,
    hoSoLuuTru,
    stepUp
  },
  state: {
    showConfirm: null,
  },
  getters: {
    showConfirm(state) {
      return state.showConfirm
    }
  },
  mutations: {
    SET_SHOW_CONFIRM(state, payload) {
      state.showConfirm = payload;
    }
  },
});
